import { Button } from '@/components/ui/button';
import { Icon } from '@/components/ui/icon';
import { Text } from '@/components/ui/text';
import { ArrowRightIcon, type LucideIcon } from 'lucide-react-native';
import { View } from 'react-native';

export function WorkspaceAccessState({
  icon,
  title,
  body,
  actionLabel,
  onAction,
}: {
  icon: LucideIcon;
  title: string;
  body: string;
  actionLabel?: string;
  onAction?: () => void;
}) {
  return (
    <View className="items-center px-6 pb-10 pt-14">
      <View className="size-14 items-center justify-center rounded-full bg-surface-alt">
        <Icon as={icon} size={24} className="text-muted-foreground" />
      </View>
      <Text className="mt-5 text-center text-2xl font-bold tracking-tight text-foreground">{title}</Text>
      <Text variant="muted" className="mt-3 max-w-[320px] text-center leading-6 text-muted-foreground">
        {body}
      </Text>
      {actionLabel && onAction ? (
        <Button className="mt-6 rounded-full px-5" onPress={onAction}>
          <Text className="font-semibold">{actionLabel}</Text>
          <Icon as={ArrowRightIcon} size={16} color="white" />
        </Button>
      ) : null}
    </View>
  );
}
